import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import { SelectOption } from '@shared/interfaces/config';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import VSelect from 'vue-select';

@Component({
  name: 'bpc-icon-select',
  components: {
    'v-select': VSelect,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class IconSelect extends mixins(AbstractField) {
  @Prop([String, Number, Boolean]) readonly value: string | number | boolean;

  @Prop([String, Number, Boolean]) readonly initialValue: string | number | boolean;

  @Prop([String]) readonly iconFolder: string;

  public icons: SelectOption[] = [];
  public loading: boolean = false;
  public iconsSubscription = null;

  get model(): string | number | boolean {
    return this.value;
  }
  set model(val: string | number | boolean) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  mounted() {
    this.loading = true;
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getTenantPath() + '/icons/get-icons'}`;

    const queryConfig = {
      params: {
        icon_folder: this.iconFolder,
      },
    };

    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(
      fetchEntityPath,
      queryConfig,
    );

    if (this.iconsSubscription) {
      this.iconsSubscription.unsubscribe();
    }

    this.iconsSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.icons = res.data || [];
        this.loading = false;
      },
      error => {
        console.log(error);
      },
    );
  }

  onChange($event) {
    this.$emit('change', $event);
  }
}
